import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../_common/_service/authservice.service';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { CommonService } from '../../../_common/_service/user.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  faqList: any;
  token: any;
  panelOpenState = false;

  constructor(private authService: AuthService,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private _service: CommonService, private router: Router) { }
    

  ngOnInit() {
    this.getFaq();
    this.token = this.tokenStorageService.getToken();


   
  }
  Back() {

    this.router.navigate(['/Go-on']);
  }
  getFaq() {

    this.authService.getFaq().subscribe(response => {
      
      if (response) {

        this.faqList = response;
        
      } 
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, "Error");
      } else {
        this.toastr.error(err.error, "Error");
      }
    }
    );
  }

}
